export function initialize(appInstance) {
  let store = appInstance.lookup("service:ember-store")
  let documentReplicator = appInstance.lookup("service:document-replicator")

  documentReplicator.start()
  // Create an anonymous user for analytics events, which use userId = "anonymous"
  // when the session is not logged in and error if they don't find a User with that id.
  store.insertDocument({
    id: "anonymous",
    type: "user",
    attributes: {
      firstName: null,
      lastName: null,
      email: null,
    },
  })

  appInstance.lookup("service:persister")
  appInstance.lookup("service:action-callbacks")
  appInstance.lookup("service:patch-callbacks")
}

export default {
  name: "store",
  initialize: initialize,
  after: ["socket"],
}
